var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#323130",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6051 2.38171C11.0384 1.42818 12.2908 1.20102 13.0314 1.94162L18.0615 6.97176C18.8021 7.71237 18.575 8.96472 17.6214 9.39804L13.1103 11.448C12.9838 11.5055 12.8868 11.6132 12.8429 11.7451L11.284 16.4215C11.2292 16.5859 11.0932 16.7102 10.9246 16.75C10.7559 16.7899 10.5787 16.7395 10.4562 16.617L7.27413 13.435L3.70711 17.002L3.70509 17H3.00206V16.2969L3 16.2949L6.56703 12.7278L3.38508 9.5459C3.26255 9.42337 3.2122 9.24613 3.25201 9.07747C3.29183 8.90882 3.41613 8.77281 3.58052 8.71801L8.25886 7.15856C8.39078 7.11459 8.49842 7.01767 8.55595 6.89108L10.6051 2.38171Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.2294015d29a66603b50991154b0331eb.svg";
export { ForwardRef as ReactComponent };